/**
 * 获取默认发言人名称
 *
 * @export
 * @param {string} [ui=''] 发言人UI
 * @returns
 */
export function getDefaultName(ui = '', roleSplited = false) {
  if (ui === '-1') {
    return '未知发言人';
  }
  if (roleSplited) {
    return `发言人 ${ui}`;
  }
  return `发言人`;
}

export default {};
